import styled from 'styled-components';

import { Breakpoint, Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Button } from '../button/button.component';

import { ContainerProps } from './pageTitle.types';

export const Container: StyledComponent<'div', ContainerProps> = styled.div<ContainerProps>`
  width: 100%;
  display: flex;
  align-items: ${({ $withDescription }: ContainerProps): string => $withDescription ? 'flex-start' : 'center'};
  justify-content: space-between;
  border-bottom: ${({ $withUnderline }: ContainerProps): string => $withUnderline ? `1px solid ${Color.Gray300}` : 'none'};
  padding-bottom: ${({ $withChildren, $withUnderline }: ContainerProps): string => !$withUnderline
    ? '0'
    : $withChildren
      ? '32px'
      : '45px'
};

  @media ${Breakpoint.Mobile} {
    flex-direction: ${({ $withDescription }: ContainerProps): string => $withDescription ? 'column' : 'row'};
  }

  @media ${Breakpoint.SmallMobile} {
    padding-bottom: ${({ $withUnderline }: ContainerProps): string => $withUnderline ? '24px' : '0'};
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Title: StyledComponent<'h1'> = styled.h1`
  font-weight: ${FontWeight.Medium};
  font-size: 30px;
  line-height: 38px;
  letter-spacing: -0.01em;
  color: ${Color.Black};
  margin-right: 15px;

  @media ${Breakpoint.SmallMobile} {
    font-size: 22px;
    line-height: 28px;
  }
`;

export const LinkButton: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  font-weight: ${FontWeight.Medium};
  font-size: 16px;
  line-height: 26px;
  text-decoration-line: underline;
  color: ${Color.Gray500};
`;

export const StyledButton: StyledComponent<typeof Button> = styled(Button)`
  flex-shrink: 0;
  
  ${LinkButton} + & {
    margin-left: 48px;

    @media ${Breakpoint.SmallMobile} {
      margin-left: 0;
      margin-top: 10px;
    }
  }

  & + & {
    margin-left: 10px;

    @media ${Breakpoint.SmallMobile} {
      margin-left: 0;
      margin-top: 10px;
    }
  }
`;

export const ChildrenContainer: StyledComponent<'div'> = styled.div``;

export const InnerContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 50%;

  @media ${Breakpoint.Mobile} {
    max-width: 100%;
  }
`;

export const DescriptionContainer: StyledComponent<'div'> = styled.div`
  width: 100%;
  font-size: 18px;
  color: ${Color.Black};
  font-weight: ${FontWeight.Light};
  line-height: 26px;

  @media ${Breakpoint.Mobile} {
    margin-top: 32px;
  }
`;

export const ButtonsContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  ${DescriptionContainer} + & {
    margin-top: 40px;
  }

  @media ${Breakpoint.SmallMobile} {
    padding-top: 8px;
    flex-direction: column;
    align-items: flex-start;
  }
`;
